import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/workspaces/$workspaceId/audit")({
	beforeLoad: ({ params }) => {
		throw redirect({ params, replace: true, to: "/admin/workspaces/$workspaceId/timeline" });
	},
});
